/* eslint-disable no-console */

export const consoleLog = warn => console.log(warn);
export const consoleWarninig = warn => console.warn(warn);
export const consoleError = error => console.error(error);



// WEBPACK FOOTER //
// ./src/app/utils.js